import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  margin-bottom: 80px;
  .empty-data-container {
    display: flex;
    margin-top: 204px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
    .image {
      width: 80px;
      margin-right: 24px;
    }
    .text {
      font-family: Lato;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      text-align: left;
      color: #161d1f;
    }
  }
`;

export const Title = styled.h1`
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  line-height: 32px;
  color: #161d1f;
  @media (min-width: 640px) {
    font-size: 24px;
  }
`;

export const Subtitle = styled.h2`
  padding-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 4px;

  > span {
    font-weight: 900;
    font-size: 16px;
    line-height: 24px;
    color: #161d1f;
  }
  > div > div:nth-of-type(1) {
    right: 3px;
  }
  p {
    font-weight: 400;
  }
`;

export const Card = styled.div`
  margin-bottom: 24px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0px 1.2px 4px #eaeef1;
`;

export const CardHeader = styled.div`
  padding: 10px 16px;
  border-bottom: 1px solid #e6edf2;

  > span {
    font-weight: 900;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const CardBody = styled.div`
  padding: 16px;
  gap: 10px;

  > hr {
    height: 1px;
    width: 100%;
    margin: 16px 0;
    display: block;
    border: none;
    background-color: #e6edf2;
  }
  b {
    font-weight: 900;
  }
  @media (min-width: 640px) {
    .credits div {
      flex-direction: row;
      font-size: 16px;
    }

    .courses div {
      flex-direction: row;
    }

    .credits span:nth-of-type(1) {
      margin-right: 8px;
      font-weight: 900;
      font-size: 16px;
    }
    .courses span:nth-of-type(1) {
      margin-right: 4px;
      font-size: 16px;
    }
  }
`;

export const CardBodyList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  > div {
    display: flex;
    flex-direction: column;
    gap: 10px;
    > div {
      > span:nth-child(1) {
        margin-right: 4px;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: #161d1f;
      }
      > span:nth-child(2) {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #161d1f;
      }
    }
  }
  @media (min-width: 640px) {
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    > div {
      display: flex;
      flex-direction: column; /* Alinea los elementos dentro de la columna verticalmente */
      flex: 1; /* Hace que cada columna ocupe el mismo espacio */
    }
  }
`;

export const CardBodyOption = styled.div`
  display: flex;
  justify-content: space-between;

  > div {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;

    > span:nth-of-type(1) {
      font-weight: 900;
      font-size: 16px;
      line-height: 24px;
    }

    > span:nth-of-type(2) {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
    }

    &::after {
      content: '';
      position: absolute;
      right: 0;
      height: 100%;
      width: 1px;
      background-color: #e6edf2;
    }

    &:last-child {
      &::after {
        display: none;
      }
    }
  }
`;

export const CardBodySlider = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  > div {
    display: flex;
    justify-content: space-between;
    border-radius: 10px;
    > span:nth-of-type(1) {
      font-weight: 900;
      font-size: 14px;
    }
  }
`;

export const ButtonTooltip = styled.button`
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  /* &:hover {
    background-color: #e2dffd;
  }

  &:focus {
    background-color: #c6c0fc;
  } */
`;

export const Info = styled.div`
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  gap: 8px;

  > span {
    color: #4f6168;
  }
`;

export const ButtonNext = styled.button`
  // height: 40px;
  width: 100%;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  // border: 1px solid #5b36f2;
  border-radius: 4px;
  background-color: #5b36f2;
  // font-weight: 700;
  color: #ffffff;
  // font-size: 12px;

  > span {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
  }

  @media (min-width: 640px) {
    width: max-content;
  }
`;

export const ContainerCredits = styled.div`
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #ffffff;
  border-radius: 8px;
  background-color: #d5e5f0;
`;
export const ContainedBoxCredits = styled.div`
  text-align: left;
  padding: 8px;
  border: 2px;
  border-radius: 4px;
  background-color: #ffffff;
  font-weight: bold;
  @media (max-width: 640px) {
    text-align: center;
  }
`;
export const DividerBox = styled.div`
  margin-top: 8px;
  padding-left: 4px;
  padding-right: 4px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
`;
export const ContainerDonutGraph = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;

export const GroupDotsItems = styled.div`
  display: flex;
  @media (max-width: 640px) {
    display: block;
  }
`;
export const SeparatorItemsDots = styled.div`
  padding: 24px;
  @media (max-width: 640px) {
    padding: 10px;
  }
`;
export const DotTypeModality = styled.div.attrs((props: any) => ({
  color: props.color
}))`
  width: 12px;
  height: 12px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const NameModality = styled.b`
  margin-left: 4px;
`;
export const ContainerDots = styled.div`
  display: flex;
  align-items: center;
`;
export const Disclaimer = styled.div.attrs((props: any) => ({
  padding: props.padding
}))`
  padding: ${(props) => props.padding};
  div {
    padding: 12px;
    display: flex;
    flex-direction: row;
    border: 1px solid #ffffff;
    border-radius: 8px;
    background-color: #d5e5f0;
    p {
      font-size: 12px;
      padding-left: 12px;
      span {
        cursor: pointer;
        text-decoration: underline;
        color: #5b36f2;
      }
    }
  }
`;
